import { render } from "./Custodian.vue?vue&type=template&id=6d98542b&scoped=true"
import script from "./Custodian.vue?vue&type=script&lang=js"
export * from "./Custodian.vue?vue&type=script&lang=js"

import "./Custodian.vue?vue&type=style&index=0&id=6d98542b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d98542b"]])

export default __exports__